import { default_header, default_header_example } from '../defaultData';

const getV10APIs = (userInfo) => {
  return [
    {
      title: '고객문의 조회',
      url: '/doc/고객문의 조회',
      data: [
        {
          version: 'v1.0',
          url: '/inquirys',
          desc: '검색 날짜안의 고객문의 내역을 조회합니다.',
          header: default_header,
          header_example: default_header_example,
          method: 'POST',
          body: [
            {
              title: 'date_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  날짜검색타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>수집일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>inq_time</code>
                          </strong>
                        </td>
                        <td>
                          <strong>문의일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>send_time</code>
                          </strong>
                        </td>
                        <td>
                          <strong>전송일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>mdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>수정일</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'sdate',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  검색시작일
                  <div className='description'>
                    (YYYY-MM-DD | YYYY-MM-DD HH:mm:ss)
                  </div>
                </div>
              ),
            },
            {
              title: 'edate',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  검색종료일
                  <div className='description'>
                    (YYYY-MM-DD | YYYY-MM-DD HH:mm:ss)
                  </div>
                </div>
              ),
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>partial</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>exact</code>
                          </strong>
                        </td>
                        <td>
                          <strong>완전일치</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>partial</code>
                          </strong>
                        </td>
                        <td>
                          <strong>부분일치</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색 키
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>inq_id</code>
                          </strong>
                        </td>
                        <td>
                          <strong>문의자아이디</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>inq_uniq</code>
                          </strong>
                        </td>
                        <td>
                          <strong>문의고유번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>inq_title</code>
                          </strong>
                        </td>
                        <td>
                          <strong>문의제목</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>상품명</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰상품코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_ord_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문번호</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <strong>
                    <ul className='style'>
                      <li>
                        <code>값을 넣지않는경우 전체검색됩니다.</code>
                      </li>
                    </ul>
                  </strong>
                </div>
              ),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'shop_cd',
              required: '',
              type: 'String',
              desc: '쇼핑몰코드',
            },
            {
              title: 'shop_id',
              required: '',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'inq_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  문의유형
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>상품문의</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>긴급메세지</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>상품평</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>고객문의</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>쇼핑몰 메세지</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'inq_status',
              required: '',
              type: 'String',
              desc: (
                <div>
                  문의상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>신규문의</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>답변작성완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>답변전송완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>확인완료</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  멀티검색 키
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰상품코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_ord_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰주문번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>invoice_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>운송장번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰아이디</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_search_word',
              required: '',
              type: 'String',
              desc: (
                <div>
                  멀티검색어
                  <div className='description'>
                    (\n으로 묶어서 전송) ex{'>'} 하나\n둘\n셋\n넷
                  </div>
                </div>
              ),
            },
            {
              title: 'masking_yn',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  개인정보 마스킹 처리 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>false</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
          ],
          body_example: {
            date_type: 'wdate',
            sdate: '2020-05-16',
            edate: '2020-06-16',
            search_type: 'partial',
            search_key: 'all',
            search_word: '',
            shop_cd: 'A006',
            shop_id: 'aghealth1',
            inq_status: '신규문의',
            multi_type: 'shop_sale_no',
            multi_search_word: '',
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object',
              desc: '',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'inq_uniq',
              required: 'O',
              type: 'String(20)',
              desc: '문의 고유번호',
              indent: 1,
            },
            {
              title: 'inq_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  문의유형
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>상품문의</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>긴급메세지</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>상품평</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>고객문의</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>쇼핑몰 메세지</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '쇼핑몰코드',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰아이디',
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String(20)',
              desc: '쇼핑몰 상품코드',
              indent: 1,
            },
            {
              title: 'shop_ord_no',
              required: 'O',
              type: 'String(120)',
              desc: '쇼핑몰 주문번호',
              indent: 1,
            },
            {
              title: 'shop_inq_no',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰 문의번호',
              indent: 1,
            },
            {
              title: 'inq_time',
              required: 'O',
              type: 'String(19)',
              desc: '문의시간',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: '문의수집시간',
              indent: 1,
            },
            {
              title: 'inq_status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  문의상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>신규문의</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>확인완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>처리완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>답변작성완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>답변전송완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>답변완료</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'inq_id',
              required: 'O',
              type: 'String(30)',
              desc: '문의자아이디',
              indent: 1,
            },
            {
              title: 'inq_name',
              required: 'O',
              type: 'String(50)',
              desc: '문의자이름',
              indent: 1,
            },
            {
              title: 'inq_title',
              required: 'O',
              type: 'String(200)',
              desc: '문의제목',
              indent: 1,
            },
            {
              title: 'inq_content',
              required: 'O',
              type: 'String(65535)',
              desc: '문의내용',
              indent: 1,
            },
            {
              title: 'inq_tel',
              required: 'O',
              type: 'String(50)',
              desc: '문의자 전화',
              indent: 1,
            },
            {
              title: 'inq_htel',
              required: 'O',
              type: 'String(50)',
              desc: '문의자 핸드폰',
              indent: 1,
            },
            {
              title: 'ans_name',
              required: 'O',
              type: 'String(60)',
              desc: '답변자명',
              indent: 1,
            },
            {
              title: 'ans_title',
              required: 'O',
              type: 'String(50)',
              desc: '답변제목',
              indent: 1,
            },
            {
              title: 'ans_content',
              required: 'O',
              type: 'String(65535)',
              desc: '답변내용',
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String(255)',
              desc: '쇼핑몰 상품명',
              indent: 1,
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '판매자관리코드',
              indent: 1,
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰명',
              indent: 1,
            },
            {
              title: 'en_sendCs_yn',
              required: 'O',
              type: 'String(1)',
              desc: '문의 답변전송가능 여부',
              indent: 1,
            },
            {
              title: 'en_sendECS_yn',
              required: 'O',
              type: 'String(1)',
              desc: '긴급메세지 답변전송가능 여부',
              indent: 1,
            },
            {
              title: 'en_snedRCS_yn',
              required: 'O',
              type: 'String(1)',
              desc: '리뷰 답변전송가능 여부',
              indent: 1,
            },
            {
              title: 'seller_nick',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰 별칭',
              indent: 1,
            },
          ],
          response_example: {
            results: [
              {
                sol_no: 999999,
                inq_uniq: '3792835769861181404',
                inq_type: '긴급메세지',
                shop_cd: 'A112',
                shop_id: 'playauto',
                shop_sale_no: '',
                shop_ord_no: '-',
                shop_inq_no: '28923605',
                inq_time: '2020-05-18 10:06:00',
                wdate: '2020-06-16 15:51:07',
                inq_status: '신규문의',
                inq_id: '',
                inq_name: '[11번가]',
                inq_title:
                  '[판매자 평점 안내] 1개 평가 항목 경고 - 2개 경고시 페널티가 적용 됩니다.',
                inq_content:
                  "[미확인]\r\n\r\n<span style='font-weight:bold'>알림내용</span> : \r\n                                <div class=\"txt_aaa marB5\">\r\n                                    [등록일 : 2020/05/18 10:06]\r\n                                    \r\n                                    <br>[알림 작성자 : 11번가]\r\n                                    \r\n                                </div>\r\n                                \r\n                                <div style=\"margin:0\">안녕하세요 11번가입니다.<br><p><b>플레이오토</b> 님은 판매자 평점에서 <b>주문이행</b> 항목의 준수율 경고를 받으셨습니다.</p><p>2개 항목에 경고를 받으면 페널티가 적용되며, 이 기간에 등록 상품은 노출이 제한됩니다.</p><p><strong style='font-size: 15px;'>오늘부터 4주 간 주문이행/발송일준수/문의응대의 고객 서비스 품질 향상에<br>집중하여 페널티의 위험에서 벗어나세요.</strong></p><p>판매자 평점은 매주 월요일(주 1회) 업데이트 됩니다.</p><p>1.노출 페널티 적용 범위 안내</p><p>- 쇼킹딜 선정 제외<br>- 기획전 편성 제외<br>- 추천영역 노출 제외<br>- 검색 결과 후순위 노출<br>- 광고품질지수 감점(광고 입찰 불이익)</p><p>2.경고 수준 평가 항목 안내</p><p>경고 수준에 도달한 이번 주 평가항목의 요약은 다음과 같으며, <br>상세한 서비스 품질 미준수 건 데이터는 판매자 평점 서비스페이지(<a href='http://soffice.11st.co.kr/view/317201' target='_blank'><b style='color: #2050ff;'>판매자 평점</b></a>)를 통해서도 확인하실 수 있습니다.</p><p>- 주문이행 : 준수율 :88.8% / 미 준수 건 : 2건 (<a href='http://soffice.11st.co.kr/view/317201#sView=eval&eType=prdCsm' target='_blank'><strong style='color: #2050ff;'>미준수 내역 전체 보기</strong></a>)</p><p>※평가기간 2020-04-11 ~ 2020-05-10</p><p>3.판매자 평점 확인 및 데이터 분석</p><p>판매자 평점은 [셀러오피스 > 회원정보 > 판매자 평점 조회] 에서<br>확인하실 수 있습니다.<br>(<a href='http://soffice.11st.co.kr/view/317201' target='_blank'><b style='color: #2050ff;'>판매자 평점</b></a>)<br>노출 대비 판매가 저조한 상품 정보를 개선하거나 가격 관리를 통해<br>상품 노출 기회를 향상 시킬 수도 있습니다.<br>자세한 내용을 확인하세요.(<a href='http://soffice.11st.co.kr/analytics/DashBoard.tmall#none' target='_blank'><b style='color: #2050ff;'>셀러 애널리틱스</b></a>)<br><p>감사합니다.</p><p>Seller Insights 팀</p></div><br>\r\n                                \r\n                                <div className=\"txt_ffa500 marT5\">[회신기한 : 2020/05/18 10:06]</div>\r\n                                \r\n                            ",
                inq_tel: '',
                inq_htel: '',
                ans_name: '',
                ans_title: null,
                ans_content: null,
                shop_sale_name: null,
                c_sale_cd: null,
                shop_name: '11번가',
                seller_nick: '테스트',
                en_sendCS_yn: 1,
                en_sendECS_yn: 1,
                en_sendRCS_yn: 0,
              },
            ],
          },
        },
      ],
    },
    {
      title: '문의답변 등록',
      url: '/doc/문의답변 등록',
      data: [
        {
          version: 'v1.0',
          url: '/inquiry/answer',
          desc: '수집한 문의의 답변을 등록합니다.',
          method: 'PUT',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'inquirys',
              required: 'O',
              type: 'Array',
              desc: '',
            },
            {
              title: 'inq_uniq',
              required: 'O',
              type: 'String',
              desc: '수집한 문의 고유번호',
              indent: 1,
            },
            {
              title: 'title',
              required: 'O',
              type: 'String',
              desc: '답변 제목',
              indent: 1,
            },
            {
              title: 'content',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  답변 내용
                  <div className='description'>
                    (줄바꿈을 할 경우 \n을 넣어 전송해주십시오)
                  </div>
                </div>
              ),
              indent: 1,
            },
          ],
          body_example: {
            inquirys: [
              {
                inq_uniq: '3792835769861181777',
                title: '답변 제목 1',
                content: '답변 내용 1',
              },
              {
                inq_uniq: '3792835769861181999',
                title: '답변제목 2',
                content: '답변 내용 2',
              },
            ],
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'inq_uniq',
              required: 'O',
              type: 'String',
              desc: '처리된 문의 고유번호',
              indent: 1,
            },
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공, 실패여부',
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '실패시 실패메세지',
              indent: 1,
            },
          ],
          response_example: {
            results: [
              {
                inq_uniq: '3792835769861181777',
                result: '성공',
                message: '',
              },
              {
                inq_uniq: '3792835769861181999',
                result: '실패',
                error_code: 'e5001',
                messages: [
                  '이미 전송완료된 문의는 답변처리가 불가능합니다.'
                ],
              },
            ],
          },
        },
      ],
    },
  ];
};

export default getV10APIs;